import { useContext } from "react";
import { Box } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import Layout from "../../layouts";
import FePageTabs from "../../components/cat15/FePageTabs";
import { OrganizationContext } from "../../contexts/OrganizationContext";

/** Persona-aware landing for /financed-emissions: borrower → My Data, lender → Dashboard. */
export const FeIndexRedirect = () => {
  const borrower = useContext(OrganizationContext)?.isCat15Borrower() ?? false;
  return (
    <Navigate
      to={
        borrower
          ? "/financed-emissions/my-data"
          : "/financed-emissions/dashboard"
      }
      replace
    />
  );
};

const FinancedEmissionsContent = () => {
  const borrower = useContext(OrganizationContext)?.isCat15Borrower() ?? false;
  return (
    // Figma node 4173:70 — 40px page padding, 20px between tab bar and content.
    // The root Layout sets color:white (for the dark sidebar/topbar); reset it
    // here so page text/tables that aren't inside a MUI Card stay readable.
    <Box
      display="flex"
      flexDirection="column"
      gap="20px"
      m="40px"
      color="var(--dark)"
    >
      {/* Borrowers have a single page (My Data) — the tab bar only helps lenders. */}
      {!borrower && <FePageTabs />}
      <Outlet />
    </Box>
  );
};

const FinancedEmissionsLayout = () => (
  <Layout>
    <FinancedEmissionsContent />
  </Layout>
);

export default FinancedEmissionsLayout;
